import { stringifyVariables } from '@urql/core'

/**
 *
 * @param {Variables} fieldArgs
 * @param {Variables} connectionArgs
 * @returns {boolean}
 */
const compareArgs = (fieldArgs, connectionArgs) => {
  for (const key in connectionArgs) {
    if (key === 'cursor' || key === 'limit') {
      continue
    } else if (!(key in fieldArgs)) {
      return false
    }

    const argA = fieldArgs[key]
    const argB = connectionArgs[key]

    if (
      typeof argA !== typeof argB || typeof argA !== 'object'
        ? argA !== argB
        : stringifyVariables(argA) !== stringifyVariables(argB)
    ) {
      return false
    }
  }

  for (const key in fieldArgs) {
    if (key === 'cursor' || key === 'limit') {
      continue
    }
    if (!(key in connectionArgs)) return false
  }

  return true
}

const offsetFromCursor = (cache, items, cursor) => {
  if (!cursor) return -1
  // debugger
  let cursorItem = atob(cursor)
  try {
    cursorItem = JSON.parse(cursorItem)
  } catch (e) {
    // Report that the cursor could not be found.
    return -1
  }
  // Search from the back of the list because the cursor we're
  // looking for is typically the ID of the last item.
  for (let i = items.length - 1; i >= 0; --i) {
    const item = items[i]

    const id = cache.resolve(item, 'id').split('/')[0]
    if (id === cursorItem.id.S) {
      // Add one because the cursor identifies the item just
      // before the first item in the page we care about.
      return i + 1
    }
  }
  // Report that the cursor could not be found.
  return -1
}

const merge = (cache, existing, incoming, cursor) => {
  // the request included a cursor
  // the cursor is where "existing" ends and "incoming" begins
  if (cursor) {
    const mergedItems = existing ? existing.slice(0) : []
    let offset = offsetFromCursor(cache, mergedItems, cursor)
    // If we couldn't find the cursor, default to appending to
    // the end of the list, so we don't lose any data.
    if (offset < 0) offset = mergedItems.length
    // Now that we have a reliable offset, the rest of this logic
    // is the same as in offsetLimitPagination.
    for (let i = 0; i < incoming.length; ++i) {
      mergedItems[offset + i] = incoming[i]
    }

    return mergedItems
  }
  // the resuest did not include a cursor
  // we can probably return the new incoming
  return incoming
}

export const monogridCMSPagination = (def) => {
  // const mergeMode = params.mergeMode || 'inwards'

  return (_parent, fieldArgs, cache, info) => {
    const { parentKey: entityKey, fieldName } = info

    const allFields = cache.inspectFields(entityKey)
    const fieldInfos = allFields.filter(info => info.fieldName === fieldName)
    const size = fieldInfos.length
    if (size === 0) {
      return undefined
    }

    const result = {
      __typename: null,
      id: null,
      items: [],
      cursor: null,
      totalCount: 0
    }

    for (let i = 0; i < size; i++) {
      const { fieldKey, arguments: args } = fieldInfos[i]
      if (args === null || !compareArgs(fieldArgs, args)) {
        continue
      }
      const incomingEntity = cache.resolve(entityKey, fieldKey)
      const newItems = cache.resolve(incomingEntity, 'items')

      if (newItems === null || newItems.length === 0) {
        continue
      }

      result.__typename = cache.resolve(incomingEntity, '__typename')
      result.items = merge(cache, result.items, newItems, args.cursor)
      result.id = cache.resolve(incomingEntity, 'id')
      result.totalCount = cache.resolve(incomingEntity, 'totalCount')
      result.cursor = cache.resolve(incomingEntity, 'cursor')
    }

    // return result
    const hasCurrentPage = cache.resolve(entityKey, fieldName, fieldArgs)
    if (hasCurrentPage) {
      return result
    } else if (!info.store.schema) {
      return undefined
    } else {
      info.partial = true
      return result
    }
  }
}
